import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const reviews = [{
  name: 'Beth A.',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&crop=face',
  text: 'Es una persona maravillosa. No solo su lectura fue precisa, tiene una manera de conectar con vos que sentís como si fuera tu mejor amiga desde el primer momento.'
}, {
  name: 'Shona M.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
  text: 'Me alegra haberla contactado. Es muy intuitiva, escribe de forma clara pero con suavidad. Sus palabras me dieron fortaleza cuando más lo necesitaba.'
}, {
  name: 'Cedie C.',
  image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=100&h=100&fit=crop&crop=face',
  text: 'Su lectura fue muy perspicaz y validó mucho de lo que ya había llegado a entender sobre la persona que consulté.'
}];
export function MoreReviews() {
  return <section className="w-full py-20 px-4 bg-[#0a0a0a]" data-id="element-217">
      <div className="max-w-6xl mx-auto" data-id="element-218">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-playfair text-3xl sm:text-4xl text-center text-white mb-16" data-id="element-219">
          Resultados de los que{' '}
          <span className="text-gradient-gold italic" data-id="element-220">no paran de hablar</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-221">
          {reviews.map((review, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-[#111] border border-white/5 p-8 rounded-2xl hover:border-[#D4AF37]/30 transition-colors flex flex-col" data-id="element-222">
              <div className="flex items-center gap-3 mb-6" data-id="element-223">
                <img src={review.image} alt={review.name} className="w-10 h-10 rounded-full object-cover border border-white/10" data-id="element-224" />
                <div data-id="element-225">
                  <p className="font-playfair text-white font-semibold text-lg" data-id="element-226">
                    {review.name}
                  </p>
                  <div className="flex gap-0.5" data-id="element-227">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3 h-3 fill-[#D4AF37] text-[#D4AF37]" data-id="element-228" />)}
                  </div>
                </div>
              </div>
              <p className="font-inter text-gray-300 text-sm leading-relaxed flex-grow" data-id="element-229">
                "{review.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}